var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfghanistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6958 1.98453C26.0664 0.713125 23.1166 0 20.0002 0C16.8838 0 13.9339 0.713125 11.3046 1.98453L9.56543 20L11.3046 38.0155C13.9339 39.2869 16.8838 40 20.0002 40C23.1166 40 26.0664 39.2869 28.6958 38.0155L30.435 20L28.6958 1.98453Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3041 1.98523C4.61429 5.22015 -0.000244141 12.0709 -0.000244141 20C-0.000244141 27.9291 4.61429 34.7798 11.3041 38.0148V1.98523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6956 1.98523V38.0148C35.3854 34.7798 39.9999 27.9291 39.9999 20C39.9999 12.0709 35.3854 5.22015 28.6956 1.98523Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 13.0436C16.1577 13.0436 13.0432 16.1581 13.0432 20.0001C13.0432 23.842 16.1577 26.9565 19.9997 26.9565C23.8417 26.9565 26.9562 23.842 26.9562 20.0001C26.9562 16.1581 23.8417 13.0436 19.9997 13.0436ZM19.9997 24.3479C17.5984 24.3479 15.6519 22.4012 15.6519 20.0001C15.6519 17.5989 17.5985 15.6523 19.9997 15.6523C22.4009 15.6523 24.3475 17.5989 24.3475 20.0001C24.3475 22.4012 22.4009 24.3479 19.9997 24.3479Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 17.3915C19.0396 17.3915 18.261 18.1701 18.261 19.1306V21.7393H21.7393V19.1306C21.7393 18.1701 20.9607 17.3915 20.0001 17.3915V17.3915Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfghanistan);
export default __webpack_public_path__ + "static/media/afghanistan.316879e193ae686f30044d13e33071a2.svg";
export { ForwardRef as ReactComponent };